import { BoxProps, Text } from '@chakra-ui/react'

import { InlineSkeleton } from '../../components/SkeletonLoader'

export const NullRenderer = ({
  size,
  styles,
  isLoading,
  ...props
}: {
  size?: string
  styles?: any
  isLoading?: boolean
} & BoxProps) => {
  const customStyles = styles && typeof styles === 'object' ? styles : {}

  return (
    <Text size={size} {...props} {...customStyles}>
      <InlineSkeleton isLoading={isLoading}>-</InlineSkeleton>
    </Text>
  )
}
